import Vue from 'vue'

// Import Icon ################################################################
//MENU ICONS
import HomeIcon from "vue-material-design-icons/HomeVariant.vue";
import Wallet from "vue-material-design-icons/Wallet.vue";
import TicketConfirmation from "vue-material-design-icons/TicketConfirmation.vue";
import PollBox from "vue-material-design-icons/PollBox.vue";
import FaceAgent from "vue-material-design-icons/FaceAgent.vue";



//SOCIAL ICONS
import Facebook from "vue-material-design-icons/Facebook.vue";
import Twitter from "vue-material-design-icons/Twitter.vue";
import Whatsapp from "vue-material-design-icons/Whatsapp.vue";
import LinkedinBox from "vue-material-design-icons/LinkedinBox.vue";
import Youtube from "vue-material-design-icons/Youtube.vue";

//OTHERS
import FolderRemoveOutline from "vue-material-design-icons/FolderRemoveOutline.vue";
import ArrowDownDropCircle from "vue-material-design-icons/ArrowDownDropCircle.vue";
import LockAlert from "vue-material-design-icons/LockAlert.vue";
import Close from "vue-material-design-icons/Close.vue";
import ShareAllOutline from "vue-material-design-icons/ShareAllOutline.vue";
import AccountMultiplePlusOutline from "vue-material-design-icons/AccountMultiplePlusOutline.vue";
import CardsOutline from "vue-material-design-icons/CardsOutline.vue";
import CheckCircle from "vue-material-design-icons/CheckCircle.vue";
import AlertCircle from "vue-material-design-icons/AlertCircle.vue";
import EyeOutline from "vue-material-design-icons/EyeOutline.vue";
import EyeOffOutline from "vue-material-design-icons/EyeOffOutline.vue";
import MenuUp from "vue-material-design-icons/MenuUp.vue";
import MenuDown from "vue-material-design-icons/MenuDown.vue";
import Plus from "vue-material-design-icons/PlusThick.vue";
import PlaylistCheck from "vue-material-design-icons/PlaylistCheck.vue";
import Reload from "vue-material-design-icons/Reload.vue";
import Menu from "vue-material-design-icons/Menu.vue";
import Magnify from "vue-material-design-icons/Magnify.vue";
import Cog from "vue-material-design-icons/Cogs.vue";
import AccountSupervisor from "vue-material-design-icons/AccountCircle.vue";
import ToyBrickOutline from "vue-material-design-icons/ToyBrickOutline.vue";
import TrashCanOutline from "vue-material-design-icons/TrashCanOutline.vue";
import GoogleAnalytics from "vue-material-design-icons/GoogleAnalytics.vue";
import WeatherNight from "vue-material-design-icons/WeatherNight.vue";
import WhiteBalanceSunny from "vue-material-design-icons/WhiteBalanceSunny.vue";
import Camera from "vue-material-design-icons/Camera.vue";
import MapMarker from "vue-material-design-icons/MapMarker.vue";
import Compass from "vue-material-design-icons/Compass.vue";
import Star from "vue-material-design-icons/Star.vue";
import EmailOpen from "vue-material-design-icons/EmailOpen.vue";
import CogBox from "vue-material-design-icons/Cogs.vue";
import BookOpenPageVariant from "vue-material-design-icons/BookOpenPageVariant.vue";
import ExitToApp from "vue-material-design-icons/ExitToApp.vue";
import AccountMultiplePlus from "vue-material-design-icons/AccountMultiplePlus.vue";
import AccountSupervisorCircle from "vue-material-design-icons/AccountSupervisorCircle.vue";
import AccountGroup from "vue-material-design-icons/AccountGroup.vue";
import AccessPointNetworkOff from "vue-material-design-icons/AccessPointNetworkOff.vue";
import Bell from "vue-material-design-icons/Bell.vue";





// //Attach to Vuejs ################################################################
// //MENU ICONS
Vue.component("ticket-icon", TicketConfirmation);
Vue.component("home-icon", HomeIcon);
Vue.component("wallet-icon", Wallet);
Vue.component("invest-icon", PollBox);
Vue.component("support-icon", FaceAgent);





//SOCIAL ICONS
Vue.component("facebook-icon", Facebook);
Vue.component("twitter-icon", Twitter);
Vue.component("whatsapp-icon", Whatsapp);
Vue.component("linkedin-icon", LinkedinBox);
Vue.component("youtube-icon", Youtube);

//OTHERS
Vue.component("empty-icon", FolderRemoveOutline);
Vue.component("lock-icon", LockAlert);
Vue.component("close-icon", Close);
Vue.component("link-icon", ShareAllOutline);
Vue.component("share-person-icon", AccountMultiplePlusOutline);
Vue.component("withdrawal-icon", CardsOutline);
Vue.component("check-icon", CheckCircle);
Vue.component("warning-icon", AlertCircle);
Vue.component("eye-open-icon", EyeOutline);
Vue.component("eye-close-icon", EyeOffOutline);
Vue.component("carret-down-circle-icon", ArrowDownDropCircle);
Vue.component("carret-up-icon", MenuUp);
Vue.component("carret-down-icon", MenuDown);
Vue.component("add-icon", Plus);
Vue.component("transactions-icon", PlaylistCheck);
Vue.component("reload-icon", Reload);
Vue.component("menu-icon", Menu);
Vue.component("search-icon", Magnify);
Vue.component("cog-icon", Cog);
Vue.component("user-icon", AccountSupervisor);
Vue.component("addon-icon", ToyBrickOutline);
Vue.component("delete-icon", TrashCanOutline);
Vue.component("analytics-icon", GoogleAnalytics);
Vue.component("night-icon", WeatherNight);
Vue.component("day-icon", WhiteBalanceSunny);
Vue.component("camera-icon", Camera);
Vue.component("map-icon", MapMarker);
Vue.component("explore-icon", Compass);
Vue.component("star-icon", Star);
Vue.component("mail-icon", EmailOpen);
Vue.component("settings-icon", CogBox);
Vue.component("blog-icon", BookOpenPageVariant);
Vue.component("exit-icon", ExitToApp);
Vue.component("invite-icon", AccountMultiplePlus);
Vue.component("co-ownership-icon", AccountSupervisorCircle);
Vue.component("crowd-funding-icon", AccountGroup);
Vue.component("bad-network-icon", AccessPointNetworkOff);
Vue.component("bell-icon", Bell);

